
// dependencies
import { Child } from 'pym.js';

// utils
import { stylePremium } from './utils/helpers';

// styles
import './styles/index.scss';


// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });;

console.clear();

window.onload = () => {


	const { pymChild } = window;
	pymChild.sendHeight();
}

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

function draw() {


}